import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLocale } from './config';

import itCommon from './locales/it/common.json';
import itHome from './locales/it/home.json';
import itMenu from './locales/it/menu.json';
import itPrenota from './locales/it/prenota.json';
import itExperiences from './locales/it/experiences.json';
import itLocation from './locales/it/location.json';
import itPalme from './locales/it/palme.json';
import itNovita from './locales/it/novita.json';
import itNotFound from './locales/it/notFound.json';
import itSeo from './locales/it/seo.json';
import itPrivacy from './locales/it/privacy.json';
import itCookiePolicy from './locales/it/cookiePolicy.json';
import itAccessibility from './locales/it/accessibility.json';
import itWagyuExperience from './locales/it/wagyuExperience.json';
import itLavoraConNoi from './locales/it/lavoraConNoi.json';
import itGiftCard from './locales/it/giftCard.json';
import itMenuFestivi from './locales/it/menuFestivi.json';

import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enMenu from './locales/en/menu.json';
import enPrenota from './locales/en/prenota.json';
import enExperiences from './locales/en/experiences.json';
import enLocation from './locales/en/location.json';
import enPalme from './locales/en/palme.json';
import enNovita from './locales/en/novita.json';
import enNotFound from './locales/en/notFound.json';
import enSeo from './locales/en/seo.json';
import enPrivacy from './locales/en/privacy.json';
import enCookiePolicy from './locales/en/cookiePolicy.json';
import enAccessibility from './locales/en/accessibility.json';
import enWagyuExperience from './locales/en/wagyuExperience.json';
import enLavoraConNoi from './locales/en/lavoraConNoi.json';
import enGiftCard from './locales/en/giftCard.json';
import enMenuFestivi from './locales/en/menuFestivi.json';

const resources = {
  it: {
    common: itCommon,
    home: itHome,
    menu: itMenu,
    prenota: itPrenota,
    experiences: itExperiences,
    location: itLocation,
    palme: itPalme,
    novita: itNovita,
    notFound: itNotFound,
    seo: itSeo,
    privacy: itPrivacy,
    cookiePolicy: itCookiePolicy,
    accessibility: itAccessibility,
    wagyuExperience: itWagyuExperience,
    lavoraConNoi: itLavoraConNoi,
    giftCard: itGiftCard,
    menuFestivi: itMenuFestivi,
  },
  en: {
    common: enCommon,
    home: enHome,
    menu: enMenu,
    prenota: enPrenota,
    experiences: enExperiences,
    location: enLocation,
    palme: enPalme,
    novita: enNovita,
    notFound: enNotFound,
    seo: enSeo,
    privacy: enPrivacy,
    cookiePolicy: enCookiePolicy,
    accessibility: enAccessibility,
    wagyuExperience: enWagyuExperience,
    lavoraConNoi: enLavoraConNoi,
    giftCard: enGiftCard,
    menuFestivi: enMenuFestivi,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  defaultNS: 'common',
  ns: [
    'common',
    'home',
    'menu',
    'prenota',
    'experiences',
    'location',
    'palme',
    'novita',
    'notFound',
    'seo',
    'privacy',
    'cookiePolicy',
    'accessibility',
    'wagyuExperience',
    'lavoraConNoi',
    'giftCard',
    'menuFestivi',
  ],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
